import React, { useEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Dark from "@amcharts/amcharts5/themes/Dark";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";

function GraficaEjes(props) {

    const rootRef = useRef(null);
    const yAxisRef = useRef(null);
    const xAxisRef = useRef(null);
    const chartRef = useRef(null);
    const legendRef = useRef(null);

    // This code will only run one time
    useEffect(() => {
        let root = am5.Root.new("chartdiv", {
            useSafeResolution: false // This may cause performance issues on some devices (like mobiles running iOS 15)
        });

        let themes = [am5themes_Animated.new(root),
        am5themes_Responsive.new(root)
        ]
        if (props.darkMode) {
            themes.push(am5themes_Dark.new(root));
        }
        root.setThemes(themes);


        let chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                panY: true,
                panX: true,
                layout: root.verticalLayout,
                wheelX: "panX",
                wheelY: "zoomX"
            })
        );

        // Create Y-axis
        let yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                renderer: am5xy.AxisRendererY.new(root, {
                    opposite: true
                }),
                min: 0,
                max: 1,
                visible: false
            })
        );

        let rendering = am5xy.AxisRendererX.new(root, {
            minGridDistance: 10
        })
        rendering.grid.template.location = 0;
        // Create X-Axis
        let xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                start: 0,
                renderer: rendering,
                categoryField: "category"
            })
        );

        rendering.grid.template.setAll({
            location: 0.5,
            multiLocation: 0
        });

        var tooltip = am5.Tooltip.new(root, {
            pointerOrientation: "down",
            //width: am5.percent(20),
            labelOversizedBehavior: "wrap"
        })

        tooltip.label.setAll({
            maxWidth: am5.percent(20),
            oversizedBehavior: "wrap"
        });


        xAxis.labelsContainer.set("tooltip", tooltip); 

        //rendering.labels.template.set("fill", am5.color("#c99"));
        //rendering.labels.template.set("tooltipText", "{orgDesc}"); <- Activar tooltip titulos eje x
        rendering.labels.template.set("oversizedBehavior", "wrap");
        rendering.labels.template.set("maxWidth", 120);
        rendering.labels.template.set("textAlign", "center");
        rendering.labels.template.setup = function (target) {
            target.set("background", am5.Rectangle.new(root, {
                fill: am5.color(0x000000),
                fillOpacity: 0
            }));
        }


        chart.set("scrollbarX", am5.Scrollbar.new(root, {
            orientation: "horizontal",
            start: 0,
        }));
        chart.set("scrollbarY", am5.Scrollbar.new(root, { orientation: "vertical" }));


        // Add cursor
        let cursor = am5xy.XYCursor.new(root, {})
        cursor.lineX.setAll({
            visible: false
        });
        chart.set("cursor", cursor);

        cursor.events.on("cursormoved", function (ev) {
            let x = ev.target.getPrivate("positionX");
            let y = ev.target.getPrivate("positionY");

            let dateX = xAxis.axisPositionToIndex(x);
            let valueY = yAxis.positionToValue(y);
            //console.log("x: ", dateX);
            //console.log("y: ", valueY);
        });

        var exporting = am5plugins_exporting.Exporting.new(root, {
            menu: am5plugins_exporting.ExportingMenu.new(root, {}),
            filePrefix: "grafica",
            title: "Graficá correlacional",
            pdfOptions: {
                includeData: true
            }
        });

        exporting.events.on("exportstarted", function (ev) {

        });

        exporting.events.on("exportfinished", function (ev) {

        });

        chart.appear(1000, 100);

        var legend = chart.children.push(am5.Legend.new(root, {
            centerY: am5.percent(50),
            y: am5.percent(97),
            x: am5.percent(10),
            width: am5.percent(90),
            height: am5.percent(12),
            verticalScrollbar: am5.Scrollbar.new(root, {
                orientation: "vertical"
            })
        }));

        /*
        legend.itemContainers.template.events.on("click", function (e) {
            var itemContainer = e.target;
            var series = itemContainer.dataItem.dataContext;
            chart.series.each(function (chartSeries) {
                if (chartSeries == series) {
                    chartSeries.strokes.template.setAll({
                        showTooltipOn: "always"
                    });
                }
            })
        })
        */

        // When legend item container is hovered, dim all the series except the hovered one
        legend.itemContainers.template.events.on("pointerover", function (e) {
            var itemContainer = e.target;

            // As series list is data of a legend, dataContext is series
            var series = itemContainer.dataItem.dataContext;

            chart.series.each(function (chartSeries) {
                if (chartSeries.strokes) {
                    if (chartSeries != series) {
                        chartSeries.strokes.template.setAll({
                            strokeOpacity: 0.15,
                            stroke: am5.color(0x000000)
                        });
                        chartSeries.bullets.clear();
                    } else {
                        chartSeries.strokes.template.setAll({
                            strokeWidth: 3,
                            showTooltipOn: "always"
                        });
                    }
                }
            })
        })

        // When legend item container is unhovered, make all series as they are
        legend.itemContainers.template.events.on("pointerout", function (e) {

            chart.series.each(function (chartSeries) {
                if (chartSeries.strokes) {
                    chartSeries.strokes.template.setAll({
                        strokeOpacity: 1,
                        strokeWidth: 1.5,
                        stroke: chartSeries.get("fill"),
                        showTooltipOn: "hover"
                    });
                    chartSeries.bullets.push(function () {

                        var circle = am5.Circle.new(root, {
                            radius: 1.8,
                            interactive: true, //required to trigger the state on hover
                            fill: chartSeries.get("fill")
                        });

                        circle.states.create('hover', {
                            scale: 3,
                        });
                        circle.set("tooltipText", "[bold]" + chartSeries._settings.name + "[/]" + chartSeries.data.values[0].tooltiptext)


                        let bullet = am5.Bullet.new(root, {
                            sprite: circle
                        });

                        return bullet

                    });
                }
            });
        })

        xAxisRef.current = xAxis;
        yAxisRef.current = yAxis;
        rootRef.current = root;
        chartRef.current = chart;
        legendRef.current = legend;

        root.numberFormatter.set("numberFormat", "#.#a");
        root.numberFormatter.setAll({
            numberFormat: "#a",
            smallNumberThreshold: 0.1
        });

        return () => {
            root.dispose();
        };
    }, []);

    useEffect(() => {
        if (rootRef.current) {
            let themes = [am5themes_Animated.new(rootRef.current),
            am5themes_Responsive.new(rootRef.current)
            ]
            if (props.darkMode) {
                themes.push(am5themes_Dark.new(rootRef.current));
            }
            rootRef.current.setThemes(themes);
        }
    }, [props.darkMode]);

    function addSeries(root, chart, yAxis, xAxis, color, variable, xField, name) {
        let series = chart.series.push(
            am5xy.LineSeries.new(root, {
                name: name,
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: variable,
                categoryXField: xField,
                fill: am5.color(color),
                stroke: am5.color(color),
                connect: false
            })
        );
        return series
    }

    // This code will only run when props.data changes
    useEffect(() => {

        // set X data
        xAxisRef.current.data.setAll(props.data.ejes);

        // clear old Y axes
        let sizeAxes = chartRef.current.yAxes.length.valueOf() - 1
        for (let index = 0; index < sizeAxes; index++) {
            chartRef.current.yAxes.pop().dispose();
        }

        // add Y axes
        let x = 0
        props.data.ejesVisibles.forEach(eje => {
            let yAxis = chartRef.current.yAxes.push(
                am5xy.ValueAxis.new(rootRef.current, {
                    renderer: am5xy.AxisRendererY.new(rootRef.current, {
                        opposite: false,
                    }),
                    min: eje.min,
                    max: eje.max,
                    x: x,
                })
            );
            x += 55
            if (eje.max <= 0.001) {
                x += 18
            }
            if (eje.max <= 0.0001) {
                x += 5
            }
            if (eje.max <= 0.000001) {
                x += 5
            }

            if (eje.max >= 100) {
                x += 18
            }
            if (eje.max >= 1000) {
                x += 5
            }
            if (eje.max >= 100000) {
                x += 5
            }

            var yRenderer = yAxis.get("renderer");
            yRenderer.ticks.template.setAll({
                //stroke: am5.color(0xFF0000),
                visible: false
            });
            yRenderer.labels.template.setAll({
                //fill: am5.color(0xFF0000),
            });
            yAxis.children.unshift(
                am5.Label.new(rootRef.current, {
                    //fill: am5.color(0xFF0000),
                    rotation: -90,
                    text: "[bold]" + eje.category + "[/]",
                    y: am5.p50,
                    centerX: am5.p50,
                    x: am5.percent(20)
                })
            );
            yRenderer.grid.template.setAll({
                visible: false,
            })
            //yAxis.set("syncWithAxis", chartRef.current.yAxes.getIndex(0));
        })

        // Clear old series
        let size = chartRef.current.series.length.valueOf()
        for (let index = 0; index < size; index++) {
            chartRef.current.series.removeIndex(0).dispose();
        }

        // Create series
        props.data.series.forEach(element => {
            let tooltipText = "\n"
            let ele = element[0]
            element.forEach(e => {
                tooltipText += e.tooltipText
                if (e.municipality) {
                    ele = e
                }
            })
            if (!ele.municipality) {
                return
            }
            tooltipText = tooltipText.replace(/\n$/, "")
            element[0]["tooltiptext"] = tooltipText.replace(/\n$/, "")

            let series = addSeries(rootRef.current, chartRef.current, yAxisRef.current, xAxisRef.current, ele.color, "value", "category", ele.municipality)
            series.data.setAll(element);
            series.strokes.template.set("tooltipText", "[bold]" + ele.municipality + "[/]" + tooltipText);
            series.strokes.template.set("tooltipX", am5.percent(50));
            series.strokes.template.set("tooltipY", am5.percent(50));
            series.strokes.template.set("strokeWidth", 2);


            series.strokes.template.set("interactive", true);
            series.strokes.template.states.create("hover", {
                //fill: am5.color("#4d8dd7"),
                strokeWidth: 5,
                stroke: am5.color(ele.color)
            });

            //console.log(series)

            var tooltip = am5.Tooltip.new(rootRef.current, {
                getFillFromSprite: false,
                getStrokeFromSprite: true,
                autoTextColor: true,
                getLabelFillFromSprite: true,
                labelText: "[bold]" + ele.municipality + "[/]" + tooltipText,
                pointerOrientation: "horizontal",
            });

            tooltip.get("background").setAll({
                fill: am5.color(0xffffff),
                fillOpacity: 0.8
            });

            if (props.tooltip) {
                series.set("tooltip", tooltip);
            }

            series.bullets.push(function () {

                var circle = am5.Circle.new(rootRef.current, {
                    radius: 2,
                    interactive: true, //required to trigger the state on hover
                    fill: series.get("fill")
                });

                circle.states.create('hover', {
                    scale: 3,
                });

                circle.set("tooltipText", "[bold]" + ele.municipality + "[/]" + tooltipText)


                let bullet = am5.Bullet.new(rootRef.current, {
                    sprite: circle
                });

                return bullet

            });

            series.appear(1000);

        });

        // Add legend
        legendRef.current.data.setAll(chartRef.current.series.values);

        // Add columns
        props.data.limites.forEach(element => {

            var series = chartRef.current.series.push(
                am5xy.ColumnSeries.new(rootRef.current, {
                    descripciones: "descripciones",
                    xAxis: xAxisRef.current,
                    yAxis: yAxisRef.current,
                    valueYField: "valueEnd",
                    categoryXField: "category",
                    openValueYField: "valueStart",
                    stroke: am5.color(element.color),
                    fill: am5.color(element.color),
                    stacked: false,
                    clustered: false,
                    //tooltip:am5.Tooltip.new(rootRef.current, {
                    //pointerOrientation:"vertical",
                    //labelText:"{descripciones}"
                    //labelText:"{name} in {categoryX}: {valueY} {info}"
                    //})
                })
            );

            var tooltip = am5.Tooltip.new(rootRef.current, {
                //width: am5.percent(20),
                labelText: "{descripciones}",
            });

            tooltip.label.setAll({
                oversizedBehavior: "wrap",
                maxWidth: am5.percent(20)
            })

            series.columns.template.setup = function (target) {
                target.set("tooltip", tooltip);
            }

            series.columns.template.setAll({
                tooltipX: am5.percent(10),
                templateField: "columnSettings",
                width: am5.percent(10),
                fillOpacity: 0.25,
                strokeOpacity: 0.25,
                //tooltipText: " ", <- Activar tooltips columnas regiones azul, naranja y gris
            });


            series.data.setAll([element]);
        })

    }, [props]);


    return <div id="chartdiv" style={{ width: "100%", height: "calc(100vh - 170px)", minHeight: "350px" }}></div>;
}


export default GraficaEjes;